"use strict";
/// <reference types="aos"/>
/// <reference types="waypoints"/>
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var AOS = __importStar(require("aos"));
require("waypoints/lib/noframework.waypoints.min.js");
var application_1 = require("./application");
require("aos/src/sass/aos.scss");
// import 'animate.css/animate.css'
require("./../scss/main.scss");
document.addEventListener('DOMContentLoaded', function (event) {
    var application = new application_1.Application();
    application.run();
    AOS.init();
    /*const animatedItems = document.querySelectorAll('.animation__waypoint');
    animatedItems.forEach(item => {
        const animation = (item as HTMLElement).dataset.animation;
        if (typeof animation === 'undefined') {
            return;
        }

        new Waypoint({
            element: item as HTMLElement,
            offset: '100%',
            handler: (direction) => {
                item.classList.add(`animate__${animation}`);
            }
        });
    });*/
    var stickyNavigation = document.querySelector('.sticky-navigation');
    var navMenu = document.querySelector('.nav-menu');
    new Waypoint({
        element: navMenu,
        offset: function () {
            return -navMenu.offsetHeight;
        },
        handler: function (direction) {
            if (direction == 'down') {
                stickyNavigation.classList.add('d-block');
            }
            else {
                stickyNavigation.classList.remove('d-block');
            }
        },
    });
    var items = document.querySelectorAll('.sticky__waypoint');
    items.forEach(function (item) {
        new Waypoint({
            element: item,
            offset: function () {
                return navMenu.offsetHeight;
            },
            handler: function (direction) {
                var currentSection = this.element;
                if (direction === 'up') {
                    currentSection = currentSection.previousElementSibling;
                }
                var currentActiveItem = stickyNavigation.querySelector('.scroll__btn.active');
                if (currentActiveItem !== null) {
                    currentActiveItem.classList.remove('active');
                }
                stickyNavigation.querySelectorAll('.scroll__btn').forEach(function (item) {
                    var scrollHref = item.dataset.scrollHref;
                    if (scrollHref == '#' + currentSection.id) {
                        item.classList.add('active');
                    }
                });
            },
        });
    });
});
